import React, { useEffect, useState } from "react";
import { Drawer, Layout } from "antd";
import { Link, Outlet } from "react-router-dom";
import DashboardSideMenu from "../components/layout/DashboardSideMenu";
import Theme from "../theme/Theme";
import MainHeader from "../components/layout/MainHeader";
import { GetDefaultPerfCycleApi } from "../api/GetDefaultPerfCycleApi";
import { useDispatch, useSelector } from "react-redux";
import { perfCycleDetails, setPerfCycleLocked } from "../features/PerfCycleSlice";
import PageLoader from "../components/sub/PageLoader";
import { setTopPlan } from "../features/TopPlanSlice";
import ChatbotWidget from "../components/Chatbot/ChatbotWidget";
import { initializeZohoConfig } from "../utils/zohoSetup";

const { Sider } = Layout;

function DashboardLayout() {
  const [loading, setLoading] = useState(true);
  const [collapsed, setCollapsed] = useState(false);
  const proWidth = document.body.clientWidth;
  const perfCycleState = useSelector((state) => state.perfCycleState.value);
  const authState = useSelector((state) => state.authState.value);
  const dispatch = useDispatch();

  useEffect(() => {
    /*In tab view collapse menu when loaded*/
    if (proWidth < 720) {
      setCollapsed(true);
    }
  }, []);

  useEffect(() => {
    if (!perfCycleState?.name) {
      getDefaultPerfCycle();
    } else {
      setLoading(false);
    }
  }, []);

  useEffect(() => {}, [perfCycleState]);

  async function getDefaultPerfCycle() {
    setLoading(true);
    const apiResponse = await GetDefaultPerfCycleApi();
    if (apiResponse.success) {
      dispatch(perfCycleDetails(apiResponse.data || {}));
      dispatch(setTopPlan(apiResponse.data?.topPlanLevelName));
      dispatch(setPerfCycleLocked(apiResponse.isLocked === true));

      // Initialize Zoho CRM configuration
      if (authState?.token) {
        initializeZohoConfig(authState.token);
      }
      
      setLoading(false);
    }
  }

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/*Main side menu*/}
      <Sider
        collapsible
        collapsed={collapsed}
        trigger={null}
        breakpoint="lg"
        style={{
          height: "100vh",
          overflow: "hidden",
          backgroundColor: Theme().sideMenu,
          borderRight: `2px solid ${Theme().navBorder}`,
        }}
        className="transparent-scroll hidden sm:block"
      >
        <Link to="/home">
          <div 
            className="logo flex items-center justify-center" 
            style={{ 
              gap: '12px',
              padding: '16px 16px 12px 16px',
            }}
          >
            <img 
              src={require('../assets/images/logo.png')} 
              alt="Strategizer" 
              style={{ 
                width: collapsed ? '32px' : '40px',
                height: collapsed ? '32px' : '40px',
                transition: 'all 0.3s'
              }} 
            />
            {!collapsed && (
              <span 
                style={{ 
                  fontSize: '20px',
                  fontWeight: 600,
                  color: Theme().textPrimary,
                  fontFamily: 'Inter, sans-serif',
                }}
              >
                Strategizer
              </span>
            )}
          </div>
        </Link>
        <DashboardSideMenu collapsed={collapsed} />
      </Sider>

      {/*Mobile side menu*/}
      <Drawer
        width="280"
        closable={false}
        placement="left"
        onClose={() => setCollapsed(true)}
        visible={!collapsed}
        className="sm:hidden "
        style={{ padding: 0 }}
        bodyStyle={{ backgroundColor: Theme().sideMenu, padding: 0 }}
      >
        <div 
          className="logo flex items-center justify-center" 
          style={{ 
            gap: '12px',
            padding: '20px 16px',
          }}
        >
          <img 
            src={require('../assets/images/logo.png')} 
            alt="Strategizer" 
            style={{ 
              width: '40px',
              height: '40px'
            }} 
          />
          <span 
            style={{ 
              fontSize: '20px',
              fontWeight: 600,
              color: Theme().textPrimary,
              fontFamily: 'Inter, sans-serif',
            }}
          >
            Strategizer
          </span>
        </div>
        <DashboardSideMenu />
      </Drawer>
      <Layout className="site-layout" style={{ overflow: 'auto', backgroundColor: Theme().background }}>
        <MainHeader
          openMenu={() => setCollapsed(!collapsed)}
          menu={collapsed}
        />
        <div style={{ overflow: 'auto', height: 'calc(100vh - 64px)', backgroundColor: Theme().background }}>
          {loading ? <PageLoader /> : <Outlet />}
        </div>
      </Layout>
      
      {/* Chatbot Widget - Only show when user is authenticated */}
      <ChatbotWidget />
    </Layout>
  );
}

export default DashboardLayout;
